import React from 'react';
import { Link } from 'react-router-dom'; // ✅ Importar Link
import './sideNavButton.css';

const SideNavButton = ({ label, icon, isActive, onClick, to }) => {
    const content = (
        <>
            <span className="material-symbols-rounded">{icon}</span>
            <h3>{label}</h3>
        </>
    );

    if (to) {
        // ✅ Si hay ruta, renderiza como Link
        return (
            <Link
                to={to}
                className={`side_nav_button ${isActive ? 'active' : ''} ${label === 'Cerrar Sesión' ? 'logout' : ''}`}
                onClick={onClick}
            >
                {content}
            </Link>
        );
    }

    // ✅ Si no hay ruta, renderiza como button normal (ej. Cerrar sesión)
    return (
        <button
            className={`side_nav_button ${isActive ? 'active' : ''} ${label === 'Cerrar Sesión' ? 'logout' : ''}`}
            onClick={onClick}
        >
            {content}
        </button>
    );
};

export default SideNavButton;
